var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.06 18.39C17.18 18.69 18.84 17.23 19.68 13.62L20.66 9.43999C21.64 5.25999 20.36 3.18999 16.17 2.20999L14.5 1.81999C11.16 1.02999 9.17001 1.67999 8.00001 4.09999M14.06 18.39C13.56 18.35 13.02 18.26 12.44 18.12L10.76 17.72C6.59001 16.73 5.30001 14.67 6.28001 10.49L7.26001 6.29999C7.46001 5.44999 7.70001 4.70999 8.00001 4.09999M14.06 18.39C13.44 18.81 12.66 19.16 11.71 19.47L10.13 19.99C6.16001 21.27 4.07001 20.2 2.78001 16.23L1.50001 12.28C0.220006 8.30999 1.28001 6.20999 5.25001 4.92999L6.83001 4.40999C7.24001 4.27999 7.63001 4.16999 8.00001 4.09999M11.64 7.52999L16.49 8.75999M10.66 11.4L13.56 12.14",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.ebcded6ab7322cd9ab2bf135ffbab030.svg";
export { ForwardRef as ReactComponent };